export const BASE_URLS: {
  [x: string]: string
} = {
  development: 'http://192.168.0.100:9012/apppocapi',
  beta: 'https://beta.chem-cloud.cn/apppocapi',
  production: 'http://apppoc.chem-cloud.cn/apppocapi'
}

